import React from "react";
import { cn } from "../utils";
import { PageSection } from "./layout";
import { KpiStrip } from "./kpi-strip";
import { FilterBar } from "./filter-bar";
import { DataPanel, ToolbarActions } from "./data-panel";

/** Standard Risk Center list page: KPI strip + filter bar + padded data panel. */
export function ModuleListPage({
  kpiItems,
  kpiCols,
  filters,
  toolbarActions,
  children,
  className,
  dataClassName,
  noPanel,
}) {
  return (
    <PageSection className={cn("p-4 sm:p-6", className)}>
      {kpiItems?.length > 0 && <KpiStrip items={kpiItems} cols={kpiCols} />}
      {(filters || toolbarActions) && (
        <FilterBar>
          {filters}
          {toolbarActions && (
            <ToolbarActions className="sm:ml-auto flex-shrink-0">
              {toolbarActions}
            </ToolbarActions>
          )}
        </FilterBar>
      )}
      {noPanel ? children : (
        <DataPanel rounded="sm">
          <div className={cn("p-5", dataClassName)}>{children}</div>
        </DataPanel>
      )}
    </PageSection>
  );
}

/** Scroll container used by Risk Center tab content in Units.js */
export function RiskCenterTabShell({ children, className }) {
  return (
    <div
      className={cn(
        "flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-auto bg-gray-50",
        className
      )}
    >
      {children}
    </div>
  );
}
